import { fetchDiscoveryURLs } from '@nubank/www-latam-commons/domains/discovery/fetchDiscoveryURLs';

export const getDiscoveryUrls = async () => {
  const discoveryURLs = await fetchDiscoveryURLs();
  return discoveryURLs;
};
